// extracted by mini-css-extract-plugin
module.exports = {"ra-footer-newsletter":"ra-footer-newsletter_ra-footer-newsletter__8IIiX","ra-footer-newsletter__wrapper":"ra-footer-newsletter_ra-footer-newsletter__wrapper__I0LRk"};